export default class ToastrHelper {

    static warning( message, title = null ) {

        toastr.warning( message, title, {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
        } );
    }

    static success( message = 'Operacija sėkmingai atlikta', title = null ) {

        toastr.success( message, title, {
            progressBar: true,
            timeOut: 5000
        } );
    }

    static errorFromAjax( jqxhr, status, text, message = 'Nepavyko atlikti operacijos', title = 'Įvyko klaida' ) {

        const exception = {
            response: {
                status: jqxhr.status,
                data: jqxhr.responseJSON,
                statusText: text
            }
        }

        return this.error( exception, message, title );
    }

    static error( exception, message = 'Nepavyko atlikti operacijos', title = 'Įvyko klaida' ) {

        console.log( exception );

        let messages = {};

        if ( exception?.response?.status === 422 ) {

            for ( let i in exception.response.data ) {

                messages[ exception.response.data[ i ].message ] = exception.response.data[ i ].message;
            }
        } else if ( exception?.response?.data?.message ) {

            messages[ exception?.response?.data?.message ] = exception?.response?.data?.message;
        } else if ( exception?.response ) {

            messages[ exception.response.statusText ] = exception.response.statusText;
        }

        messages = Object.values( messages );

        toastr.error( message + ( messages.length ? ':<br />' + messages.join( '<br/>' ) : '' ), title, {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
        } );
    }
}